export default function bfCachePersists(callback = function () {}) {
    window.addEventListener('pageshow', function (event) {
        let performance = window.performance ? window.performance.toJSON() : null;
        if (event.persisted || (performance !== null && performance.navigation.type === 2)) {
            callback();
        }
    });
}
